import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Compass } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 pt-10 pb-16">
        <div className="text-center max-w-md">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-6">
            <Compass className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-6xl font-bold text-foreground mb-3">404</h1>
          <p className="text-xl font-semibold text-foreground mb-2">Página não encontrada</p>
          <p className="font-body text-muted-foreground mb-8 leading-relaxed">
            O endereço que você tentou acessar não existe ou foi movido. Vamos te levar de volta ao início.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-3 rounded-lg font-medium transition-colors"
          >
            Voltar ao início
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
